import { isParticipantFacingRoute, isParticipantTaskRoute } from '~/utils/participantRoute';
import {
  resolveParticipantPortalLocale,
  resolveParticipantTaskLocale,
} from '~/utils/participantUiLocale';
import {
  resolveParticipantHtmlLang,
  resolveParticipantTextDirection,
} from '~/utils/participantTextDirection';

export default {
  computed: {
    participantPortalLocale() {
      if (!isParticipantFacingRoute(this.$route)) {
        return null;
      }

      return resolveParticipantPortalLocale({
        user: this.$auth?.user,
        query: this.$route.query,
      });
    },

    participantTaskLocale() {
      if (!isParticipantFacingRoute(this.$route) || !isParticipantTaskRoute(this.$route)) {
        return null;
      }

      const task = this.$store?.getters?.['tasks/task'];

      if (!task?.language) {
        return null;
      }

      return resolveParticipantTaskLocale({
        query: this.$route.query,
        task,
      });
    },

    participantRouteLocale() {
      return this.participantPortalLocale;
    },

    participantDocumentDirection() {
      if (!this.participantPortalLocale) {
        return null;
      }

      return resolveParticipantTextDirection(this.participantPortalLocale);
    },

    participantTaskDocumentDirection() {
      if (!this.participantTaskLocale) {
        return null;
      }

      return resolveParticipantTextDirection(this.participantTaskLocale);
    },

    participantHtmlLang() {
      if (!this.participantPortalLocale) {
        return null;
      }

      return resolveParticipantHtmlLang(this.participantPortalLocale);
    },

    participantTaskHtmlLang() {
      if (!this.participantTaskLocale) {
        return null;
      }

      return resolveParticipantHtmlLang(this.participantTaskLocale);
    },
  },
};
